module.exports = __webpack_public_path__ + "static/media/Atalanta.141b1d0e.jpg";